import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const ROUNDED_DESKTOP_WIDTH = '18rem'
const DEFAULT_DESKTOP_WIDTH = '25.6rem'

export const SrpSortContainer = styled.div<{ isRoundedSelect: boolean }>(
  ({ theme, isRoundedSelect }) => `
  height: 4.8rem;
  width: 100%;
  
  ${MEDIA_QUERIES(theme).medium}{
    width: ${isRoundedSelect ? ROUNDED_DESKTOP_WIDTH : DEFAULT_DESKTOP_WIDTH};
  }
`
)

export const SrpResultsSortContainer = styled.div(
  ({ theme }) => `
  ${MEDIA_QUERIES(theme).large} {
    min-width: 42rem;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`
)
